/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, Solution} from '@exc/core/src/models/Solution';

const sideNav = {
  menu: [
    {icon: 'Report', id: 'reports', name: 'Impressions Report', url: '/primetime/dai/reporting'},
    {icon: 'BranchCircle', id: 'ad_config', name: 'Ad-Rules', url: '/primetime/dai/config'}
  ]
};

export const ptHome: Solution = {
  appId: 'PTHome',
  appRoot: 'PTHome',
  distributionList: ['Grp-adiosUI-engg'],
  path: '/primetime/home',
  redirectFrom: [{path: '/primetime', options: {end: true}}],
  spaAppId: 'PTUnifiedUI-home',
  serviceCode: 'dma_primetime',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:8013',
      prod: '' //TODO: Remove this line before the production release.
    }
  },
  access: {code: ['dma_primetime']}
};

export const ssaiHome: Solution = {
  appId: 'ssaihomeui',
  appRoot: 'PTHome',
  distributionList: ['Grp-adiosUI-engg'],
  path: '/primetime/dai/home',
  spaAppId: 'adios-ssaihome',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:8013',
      prod: '' //TODO: Remove this line before the production release.
    }
  },
  access: {code: ['dma_primetime']}
};

export const ptAdConfig: Solution = {
  appId: 'adconfigui',
  appRoot: 'PTHome',
  distributionList: ['Grp-adiosUI-engg'],
  path: '/primetime/dai/config',
  spaAppId: 'adios-adconfig',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:8013',
      prod: '' //TODO: Remove this line before the production release.
    }
  },
  access: {code: ['dma_primetime']},
  sideNav
};

export const adReporting: Solution = {
  appId: 'adreportingui',
  appRoot: 'PTHome',
  distributionList: ['Grp-adiosUI-engg'],
  path: '/primetime/dai/reporting',
  redirectFrom: [{path: '/primetime/dai'}],
  spaAppId: 'adios-reporting',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:8013',
      prod: '' //TODO: Remove this line before the production release.
    }
  },
  access: {code: ['dma_primetime']},
  sideNav
};
